<template>
  <VLayout upline :title="$t('privacy_policy.title')">
    <VMarkdownView :mdtext="$t('privacy_policy.legal_text')" class="text-justify" />
  </VLayout>
</template>

<script>
import VLayout from "@/layouts/Default";
import VMarkdownView from "@/components/VMarkdownView";
import privacy_policy_es_mx from "raw-loader!@/static/PRIVACY_POLICY_es-MX.txt";
import privacy_policy_en_us from "raw-loader!@/static/PRIVACY_POLICY_en-US.txt";

import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
  },
  fallbackI18n: {
    messages: {
      und: {
        privacy_policy: {
          title: "Global PDV privacy policy",
          legal_text: privacy_policy_en_us,
        },
      },
    },
  },
  i18n: {
    messages: {
      "es-MX": {
        privacy_policy: {
          title: "Aviso de privacidad Global PDV",
          legal_text: privacy_policy_es_mx,
        },
      },
      "en-US": {
        privacy_policy: {
          title: "Global PDV privacy notice",
          legal_text: privacy_policy_en_us,
        },
      },
    },
  },
  mounted: function() {
    this.putBreadCrumb();
  },
  methods: {
    putBreadCrumb() {
      this.$store.commit("siteconf/MUTATE_BREADCRUMB", [
        {
          langkey: "breadcrumb.home",
          to: { name: "home" },
        },
        {
          langkey: "privacy_policy.title",
          to: { name: "privacy-policy" },
        },
      ]);
    },
  },

  components: {
    VLayout,
    VMarkdownView,
  },
};
</script>

<style lang="scss">
ol {
  list-style-type: upper-roman;
}
</style>
